import { gql } from '@apollo/client';
import Fragments from './components/fragments';
import CommonFragments from 'features/common/fragments';

export const ITEM_GENERAL_DATA_SAVED = gql`
  subscription itemGeneralDataSaved {
    itemGeneralDataSaved {
      item {
        id
        code
        name
        shortName
        typeId
        typeCode
        typeName
        enabled
        description
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const PROPERTY_GENERAL_DATA_SAVED = gql`
  subscription itemPropertyGeneralDataSaved {
    itemPropertyGeneralDataSaved {
      itemProperty {
        ...itemProperty
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.itemProperty}
  ${CommonFragments.messageHeaders}
`;

export const PROPERTY_VALUES_SAVED = gql`
  subscription propertyValuesSaved {
    propertyValuesSaved {
      propertyValues {
        propertyValueId
        value
        propertyMinValue
        propertyMaxValue
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const PROPERTY_VALUE_SAVED = gql`
  subscription propertyValueSaved {
    propertyValueSaved {
      propertyValue {
        propertyValueId
        value
        propertyMinValue
        propertyMaxValue
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const ITEM_REMOVED = gql`
  subscription itemRemoved {
    itemRemoved {
      itemId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const ITEM_PROPERTY_REMOVED = gql`
  subscription itemPropertyRemoved {
    itemPropertyRemoved {
      propertyId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const PROPERTY_VALUE_REMOVED = gql`
  subscription propertyValueRemoved {
    propertyValueRemoved {
      itemProperty {
        ...itemProperty
      }
      propertyValueId
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.itemProperty}
  ${CommonFragments.messageHeaders}
`;
